export enum ComponentId {
  DATE = "date",
  HOUR = "hour",
  PLACE = "place",
  CITY = "city",
  ZIP_CODE_PL = "zipCodePL",
  ZIP_CODE_GENERIC = "zipCodeGeneric",
  COUNTRY = "country",
  PROVINCE = "province",
  DESCRIPTION = "description",
}
